// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"e789d67f","488":"f1f1b2fe"}[chunkId] + ".chunk.js";
};